import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { _ } from "src/services";
import { Modals, ModalsAction } from "src/store";
import { ProfileOutline } from "../svg";
import { Modal } from "./modal";

export const ProfileModal: React.FC = () => {

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);

    const onClose = () => dispatch(ModalsAction.hideProfile());

    //#region helpers

    const renderFooter = () => {
        return (
            <>
                <div className="col-6 col-md-5">
                    <NavLink onClick={onClose} to="/profile/edit" className="w-100 btn focusable btn-submit">{_("completeProfileButton")}</NavLink>
                </div>
                <div className="col-6 col-md-5 offset-md-2">
                    <button onClick={onClose} className="w-100 btn btn-cancel">{_("cancel")}</button>
                </div>
            </>
        );
    };


    const renderBody = () => {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="profile-icon"> <ProfileOutline /></div>
                <p className="text-center rtl">{_("completeProfileMessage")}</p>
            </div>
        );
    };

    //#end region

    return (
        <Modal title={_("completeProfileTitle")} show={modals.profile} onClose={onClose} renderFooter={renderFooter} className="modal-component--profile ltr">
            <div className="content text-right">
                {renderBody()}
            </div>
        </Modal>
    );

};